import React from 'react';
import PropTypes from 'prop-types';

import {connect, ssr_wait} from '@stubhub/react-store-provider';

import getEventsJSONLDMeta, {checkJSONLDAndMicroDataEnabled} from '../../../helpers/jsonld-helper';
import SEOJSONLDElement from '../../../modules/react-seo-jsonld-element';

import controller from './controller';

class EventSEOList extends React.Component {
  @ssr_wait
  init() {
    const {loadEvents} = this.props;

    return loadEvents(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {loadEvents, entityId} = this.props;

    /**
     * Re-initialize if the current `id` is not the same a `nextProps.id` (Route change)
     *
     */
    if (entityId !== nextProps.entityId) {
      return loadEvents({...nextProps});
    }
  }

  UNSAFE_componentWillMount() {
    const {events} = this.props;
    if (events && events.length === 0) {
      this.init();
    }
  }

  render() {
    const {events, localCountry, defaultWebTLD, maxItemCount, entityId} = this.props;
    const {globalRegistry} = this.context;
    const {jsonldToggle} = checkJSONLDAndMicroDataEnabled(globalRegistry, events, entityId);
    const redirectionDomain = globalRegistry.getPropertyValue(`tb.eventpage.url.domain.${defaultWebTLD}`) || '';
    const jsonld = jsonldToggle
      ? getEventsJSONLDMeta(events, localCountry, defaultWebTLD, maxItemCount, redirectionDomain)
      : null;
    /* istanbul ignore else */
    if (jsonldToggle && jsonld) {
      return <SEOJSONLDElement jsonld={jsonld} />;
    }

    return null;
  }

  componentWillUnmount() {
    const {resetEvents} = this.props;
    resetEvents();
  }
}

EventSEOList.propTypes = {
  /**
   * Method to reset the Events
   */
  resetEvents: PropTypes.func.isRequired,

  /**
   * Function to call for loading events
   */
  loadEvents: PropTypes.func.isRequired,

  /**
   * Array of events
   */
  events: PropTypes.array,

  /**
   * The ID of the Entity of the parent which should be used in the search specification.
   */
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  localCountry: PropTypes.string,

  /**
   * Default TLD for the site
   */
  defaultWebTLD: PropTypes.string,
};

EventSEOList.contextTypes = {
  queue: PropTypes.object,
  globalRegistry: PropTypes.object,
};

EventSEOList.propTypes = {
  maxItemCount: PropTypes.number,
};

EventSEOList.defaultProps = {
  maxItemCount: 10,
};

export {EventSEOList};

export default connect(controller)(EventSEOList);
